import { render, staticRenderFns } from "./PassengerInfants.vue?vue&type=template&id=1c2813a6&"
import script from "./PassengerInfants.vue?vue&type=script&lang=js&"
export * from "./PassengerInfants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports